export const en = {
  common: {
    home: "Home",
    no_scores: "No scores yet",
    points_count_one: "{{count}} point",
    points_count_other: "{{count}} points",
    questions_count_one: "{{count}} question",
    questions_count_other: "{{count}} questions",
  },
  home: {
    placeholder: "Game code",
    enter: "Enter",
    error_invalid_code: "Enter the 6-character game code from your teacher.",
    footer: "Start a Binogi Buzz from Binogi.com products.",
    language_label: "Language",
  },
  // What a screen shows for a server ERROR frame, by error code (see
  // SERVER_ERROR_KEYS in lib/i18n.ts). The server's own English message is
  // never shown.
  errors: {
    generic: "Something went wrong. Please try again.",
    stale_client: "Your page is out of date — please refresh.",
    session_not_found: "Couldn't find this session.",
    session_not_open: "This session has finished.",
    session_not_active: "This question or session has already ended.",
    not_teacher: "Only the teacher can do that.",
    already_answered: "You've already answered this question.",
    wrong_question_index: "This question hasn't started yet.",
    name_taken: "That name is already taken. Try another one.",
    character_busy: "Couldn't get you a character just now — please try again.",
  },
  host: {
    input: {
      heading: "Start a Buzz",
      lead:
        "Enter the Binogi lesson code your students are studying. We'll load its questions and create a session you can project on the board.",
      lesson_code_label: "Lesson code",
      placeholder_code: "BIH750",
      load_button: "Load lesson",
      try_hint: "Try:",
      error_invalid_code: "Enter a Binogi lesson code, e.g. BIH750.",
      error_not_found: "No lesson found for code {{code}}.",
      error_unreachable:
        "Could not reach the lesson server. Check your connection and try again.",
      error_no_questions: "Lesson {{code}} has no questions Buzz can use.",
      error_no_level_questions:
        "Lesson {{code}} has no questions at the chosen level.",
    },
    loading: "Loading lesson…",
    placeholder_title: "Start a Binogi Buzz",
    tab_details: "Details",
    tab_questions: "Questions",
    settings: "Settings",
    number_of_students: "Number of students",
    fewer_students: "Fewer students",
    more_students: "More students",
    player_names: "Player names",
    player_anonymous: "Anonymous",
    player_self_chosen: "Students choose",
    language: "Language",
    language_teacher: "Teacher chooses",
    language_students: "Students choose",
    time_per_question: "Time per question",
    time_option: "{{seconds}}s",
    start_button: "Start session",
    start_disabled: "Set class size to start",
    creating: "Creating session…",
    error_no_questions: "Keep at least one question before starting.",
    error_create_failed: "Failed to create session.",
    error_load_failed: "Failed to load lesson.",
    no_session: "No session in progress.",
    back_to_review: "Back to question review",
    errors: {
      dismiss: "Dismiss",
      refresh: "Refresh",
      attach_failed: "Could not attach as host.",
      unreachable:
        "Could not reach the host server. Refresh the page to try again.",
      no_token:
        "This tab can no longer control the quiz. Open Buzz from your lesson to start a new session.",
      taken_over: "This quiz is now being run from another screen.",
      stale_question:
        "Buzz was updated during this quiz, so this screen can no longer continue it. Reload the page to pick the quiz up where the class is.",
      question_moved_on:
        "The quiz has already moved on, so this screen is behind it. Reload the page to pick the quiz up where the class is.",
    },
    entry: {
      opening: "Opening teacher view…",
      token_title: "This teacher link can't be opened",
      token_body:
        "The host token is missing or expired. Open Buzz from your lesson to create a fresh session.",
      not_found_title: "Session not found",
      not_found_body:
        "This quiz session no longer exists. Create a new one to keep going.",
      back: "Back to host",
    },
    questions: {
      drag_aria: "Drag to reorder",
      remove_aria: "Remove question",
      empty: "No questions left in this session.",
      add: "Add",
      add_aria: "Add question: {{text}}",
      add_all: "Add all",
      add_all_n: "Add all {{count}} questions",
      more_one: "{{count}} more question in this lesson",
      more_other: "{{count}} more questions in this lesson",
      level_easy: "Easy",
      level_medium: "Medium",
      level_hard: "Hard",
      multi: "Multi",
    },
    lobby: {
      go_to: "Go to <strong>buzz.binogi.com</strong> and enter:",
      or_qr: "…or scan the QR code",
      students_joined_of:
        "{{joined}} of {{expected}} students joined",
      students_joined_one: "{{count}} student joined",
      students_joined_other: "{{count}} students joined",
      waiting: "Waiting for students to join…",
      start_game: "Start game",
      connected: "Connected",
      connecting: "Connecting…",
      copy_link: "Copy link",
      copy_link_copied: "Copied!",
    },
    question: {
      header: "Question {{index}} of {{total}}",
      level: "Level {{level}}",
      none: "No active question.",
      answered: "Answered",
      top_n: "Top {{count}}",
      answers_heading: "Answers",
      end_question: "End question",
      next_question: "Next question",
      see_results: "See final results",
    },
    results: {
      heading: "Final results",
      all_players: "All players",
      end_session: "End session",
      new_session: "New session",
      none: "No players in this session.",
    },
  },
  join: {
    code_label: "Game code",
    name_label: "Your name",
    name_placeholder: "Type your name",
    join_button: "Join",
    joining: "Joining…",
    checking: "Checking…",
    character_hint: "You'll get a fun Binogi character name when you join.",
    error_not_found:
      "That code isn't a live session yet. Check it with your teacher.",
    error_lookup_failed: "Failed to look up session",
    error_code_required: "Enter the 6-character code.",
    error_name_required: "Enter your name.",
  },
  play: {
    superseded: "You're connected in another tab — close it to keep playing here.",
    back_to_join: "Back to join",
    no_round: "No round data.",
    not_joined: "You haven't joined a session.",
    no_question: "No active question.",
    keep_awake_hint: "Tap the screen to keep it awake",
    waiting: {
      you_are: "You are",
      get_ready_named: "Get ready, {{name}}!",
      get_ready: "Get ready for the quiz!",
      in_room_label: "Students in the room",
      in_room_one: "{{count}} student in the room",
      in_room_other: "{{count}} students in the room",
    },
    question: {
      progress: "{{index}} / {{total}}",
      answered: "Answered!",
      times_up: "Time's up",
      submit: "Submit",
      submit_n: "Submit {{count}} answers",
    },
    between: {
      correct: "Correct!",
      wrong: "Not quite!",
      times_up: "Time's up",
      points_gained: "+{{count}} points",
      your_score: "Your score",
      your_rank: "You are #{{rank}}",
      top_n: "Top {{count}}",
      waiting_next: "Waiting for the next question…",
    },
    finished: {
      heading: "Thanks for playing Binogi Buzz!",
      your_final_rank: "Your final rank",
      top_n: "Top {{count}}",
      none: "No results to show.",
    },
  },
  characters: {
    heading: "Binogi characters",
    lead:
      "{{count}} students get a character when they join, in this order.",
  },
};

export type TranslationKeys = typeof en;

// English has two plural categories (_one, _other); Arabic, Polish,
// Russian and Ukrainian use more (CLDR: ar zero/two/few/many, pl/ru/uk
// few/many). i18next picks the category with Intl.PluralRules and, when
// the locale lacks that key, falls back to English. A locale typed as
// `Locale` may add those forms next to any `<key>_other` pair.
type ExtraPluralKeys<K> = K extends `${infer Base}_other`
  ? `${Base}_${"zero" | "two" | "few" | "many"}`
  : never;
export type Locale<T = typeof en> = {
  [K in keyof T]: T[K] extends string ? string : Locale<T[K]>;
} & { [K in ExtraPluralKeys<keyof T>]?: string };
